import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';
import { GetBy } from '../_app/cuchillo/core/Element';
import gsap, { Power2 } from 'gsap';

class ScrollItem__Perfumes extends ScrollItem__BlockDefault {
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this.timeline = gsap.timeline({ paused: true });
    this.setupText();

    this.onShow = () => {
      this.showCb();
      this.timeline.restart();
    };

    this.onHide = () => {};
    this.onMove = () => {};
  }

  setupText() {
    const lines = [...GetBy.class('line', this.item)];
    let delay = .2;
    let oldParent = null;

    lines.forEach(dom => {
      if (oldParent && oldParent !== dom.dataset.parent) delay += .3;
      oldParent = dom.dataset.parent;

      this.timeline.from(dom, {
        opacity: 0,
        duration: .2,
        ease: Power2.easeIn,
      }, delay);

      delay += 0.1;
    });
  }
}

Scroll._registerClass('perfumes', ScrollItem__Perfumes);
